import classNames from 'classnames';
import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import React from 'react';

const IconContents: React.FC<CardContentsComponent<'icon'>> = ({ icon }) => {
  const { name, color, backgroundColor, className, title } = icon;

  return (
    <i
      slot='icon'
      data-title={title}
      className={classNames(name, className)}
      style={{ color, backgroundColor }}
    />
  );
};

export default IconContents;
